import * as options from '../common/optionMap';
import dateFns from 'date-fns';
import {
  getReversibleCityName,
  regionHelper,
  filterCapital,
  filterEstablishDate
} from '../common/utils.js';
import { municipality } from '../common/administrativeAreas';

const filters = {
  /* 文件大小转换 */
  fileSize(value) {
    try {
      const m = value / 1024 / 1024;
      return value == 0 ? 0 : m.toFixed(2);
    } catch (error) {
      return 0;
    }
  },
  /* 搜索引擎转码 */
  sourceToName(value) {
    try {
      const nameObj = {
        BaiduCompany: '百度',
        '360Company': '360',
        SogouCompany: '搜狗',
        BiyingCompany: '必应'
      };
      return value ? nameObj[value] : '-';
    } catch (error) {
      return '-';
    }
  },
  hireToName(value) {
    try {
      const nameObj = {
        LaGouCompany: '拉勾网',
        DajieCompany: '大街网',
        YingcaiZhaopin: '英才网',
        SogouCompany: '搜狗',
        Hunt007Company: 'hunt007',
        ZhiYouJiCompany: '职友集',
        'SanLiuRenCaiWang ': '36人才网',
        KanzhunCompany: '看准网',
        GanJiWangCompany: '赶集网',
        '58Company': '58同城',
        BaiduZhaopinCompany: '百度招聘',
        JunCaiZhaopinCompany: '俊才招聘',
        ZhiLianZhaopingCompany: '智联招聘',
        '51JobCompany': '51Job',
        BaiDaCompany: '百大英才网',
        BossZhiPinKeyword: 'BOSS直聘',
        BLZPCompany: '伯乐招聘'
      };
      return value ? nameObj[value] : '-';
    } catch (error) {
      return '-';
    }
  },
  /*  时间秒 转 时间 hh:mm:ss */
  secToTime(s) {
    let t;
    if (s > -1) {
      var hour = Math.floor(s / 3600);
      var min = Math.floor(s / 60) % 60;
      var sec = s % 60;
      if (hour < 10) {
        t = '0' + hour + ':';
      } else {
        t = hour + ':';
      }

      if (min < 10) {
        t += '0';
      }
      t += min + ':';
      if (sec < 10) {
        t += '0';
      }
      t += sec.toFixed(0);
    }
    return t;
  },

  /*字符串显示固字数超出...代替*/
  fiexdStrLength(value, length) {
    let newValue = value;
    if (value) {
      newValue =
        value.length > length ? value.substring(0, length) + '...' : value;
    }
    return newValue;
  },
  /* sem推广类型 */
  semSourceType(value) {
    let newValue = '-';
    if (value == 1) {
      newValue = '网页';
    } else if (value == 2) {
      newValue = '移动端';
    } else if (value == 3) {
      newValue = '其他';
    }
    return newValue;
  },
  /**
   * 数字千分位
   * @param {number} value - 数字
   * @returns {string}
   */
  thousands(value) {
    if (!isNaN(value) && value != null && value != 0) {
      let s = parseFloat((value + '').replace(/[^\d.-]/g, '')) + '';
      let l = s
        .split('.')[0]
        .split('')
        .reverse();
      let t = '';
      for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
      }
      return t
        .split('')
        .reverse()
        .join('');
    } else if (value == 0) {
      return 0;
    } else {
      return '-';
    }
  },
  /*字符串时间转格式*/
  dateFormatString(value) {
    let newValue = value;
    if (value != null && value != '' && value.length > 6) {
      const date = new Date(value);
      const dateSends = date.getTime(); /* +8*60*60*1000 */
      newValue = filters.dateFormat(dateSends, 'yyyy-MM-dd');
      return newValue;
    } else {
      return '-';
    }
  },
  /*地区到字符串*/
  regionTostring(value) {
    let [province, city, area] = ['', '', ''];
    switch (value.length) {
      case 2:
        province = value;
        break;
      case 4:
        province = value.substring(0, 2);
        city = value;
        break;
      case 6:
        province = value.substring(0, 2);
        if (municipality.indexOf(value) >= 0) {
          city = value;
        } else {
          city =
            value.substring(0, 4) == '5002' ? '5001' : value.substring(0, 4);
        }
        // city = value.substring(0, 4) == '5002' ? '5001' : value.substring(0, 4);
        area = value;
        break;
      default:
        break;
    }
    return getReversibleCityName(province, city, area);
  },
  scopeToString(value) {
    return `搜索范围：${options.scopeList[value]}`;
  },
  /*营业状态到字符串*/
  entstatusTostring(value) {
    let targetArr = options.openStatusMap.filter(item => {
      return item.key == value;
    });
    return targetArr[0].value;
  },
  // 行业转字符串 一级
  industryshortString(value) {
    return options.industryMap[value];
  },
  // 行业转字符串 一级
  industryshortToString(value) {
    let reserveMath = options.industryMapMathResver[value];
    return options.industryMap[reserveMath];
  },
  // 二级
  secIndustryshortToString(value) {
    // let reserveMath = options.industryMapMathResver[value];
    return options.industrySubMap[value];
  },
  /*企业类型到字符串*/
  enttypeToString(value) {
    try {
      let targetArr = options.enttypeMapTop.filter(item => {
        return item.key == value;
      });
      return targetArr[0].value;
    } catch (error) {
      return '';
    }
  },
  commonToString(value, key) {
    try {
      let targetArr = options[key].filter(item => {
        return item.key == value;
      });
      return targetArr[0].value;
    } catch (error) {
      return '';
    }
  },
  establishmentTostring(value) {
    try {
      let targetArr = options.createDateOptions.filter(item => {
        return item.value == value;
      });
      return targetArr[0].label;
    } catch (error) {
      return filterEstablishDate(value);
    }
  },
  /*企业来源到字符串*/
  sourceToString(value) {
    let targetArr;
    let now = new Date();
    let nowYear = now.getFullYear();
    // // 动态显示最近5年的年报，每年的06月01日后才显示上一年的年报
    let divideDate = new Date(nowYear + '-6-1 00:00:00').getTime();
    let reportYearMin = nowYear - 5;
    let reportYearMax = nowYear - 1;
    if (now.getTime() < divideDate) {
      reportYearMin--;
      reportYearMax--;
    }
    let middleYear = 2014, //reportYearMin,
      id = 123,
      YearArr = [],
      YearArrNum = [];
    for (middleYear; middleYear <= reportYearMax; middleYear++) {
      let currentItem = {
        id: id,
        nameCn: middleYear + '年年报',
        name: ''
      };
      YearArr.unshift(currentItem);
      YearArrNum.unshift(id);
      // middleYear++;
      id++;
    }
    if (YearArrNum.indexOf(value) != -1) {
      targetArr = YearArr.filter(item => {
        return item.id == value;
      });
    } else {
      targetArr = options.sourceMap.filter(item => {
        return item.id == value;
      });
    }
    return targetArr[0].nameCn;
  },
  /*招聘情况到字符串*/
  recruitToString(value) {
    let str = '';
    switch (value) {
      case '1':
        str = '有招聘信息';
        break;
      case '2':
        str = '无招聘信息';
        break;
      default:
        break;
    }
    return str;
  },
  /*联系方式到字符串*/
  contactTostring(value) {
    let targetArr = options.contactMap.filter(item => {
      return item.key == value;
    });
    return targetArr[0].value;
  },
  /*注册资本到字符串*/
  capitalTostring(value) {
    try {
      let targetArr = options.capitalOptions.filter(item => {
        return item.value == value;
      });
      return targetArr[0].label;
    } catch (error) {
      return value ? filterCapital(value) : value;
    }
  },
  /**
   * 时间转换
   * @param {number} date - 时间戳
   * @param {string} fmt - 格式
   * @returns {string}
   */
  dateFormat(date, fmt) {
    if (!isNaN(date) && date != null && date != '' && date != 0) {
      let dateNumber = Number(date);
      let str = new Date(dateNumber);
      let obj = {
        'M+': str.getMonth() + 1,
        'd+': str.getDate(),
        'h+': str.getHours(),
        'm+': str.getMinutes(),
        's+': str.getSeconds(),
        'q+': Math.floor((str.getMonth() + 3) / 3),
        S: str.getMilliseconds()
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (str.getFullYear() + '').substr(4 - RegExp.$1.length)
        );
      for (let k in obj)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? obj[k]
              : ('00' + obj[k]).substr(('' + obj[k]).length)
          );
      return fmt;
    } else {
      return '-';
    }
  },

  displayRegionTag(num, flattenOptions) {
    if (num == '0') return '';

    let prefix = '';
    if (regionHelper.isCity(num)) {
      prefix = flattenOptions[regionHelper.parseProvince(num)].NAME;
    } else if (regionHelper.isDistrict(num)) {
      prefix = flattenOptions[regionHelper.parseCity(num)].NAME;
    }
    return (
      '所在地区：' + (prefix ? prefix + '-' : '') + flattenOptions[num].NAME
    );
  },

  telephoneStatus(item = {}) {
    switch (+item.numStatus) {
      case 1:
        return '正常';
      case 2:
        return '异常';
      case 3:
        return '未知';
      case 4:
        return '已屏蔽';
      case 5:
        return '疑似代理记账';
      default:
    }
  },

  telephoneStatusDetail(item = {}) {
    let prefix = '号码检测结果 ：';
    let content = '';
    switch (+item.numStatus) {
      case 1:
        content = '正常';
        break;
      case 2:
        content = '异常';
        break;
      case 3:
        content = '未知';
        break;
      case 4:
        content = '已屏蔽';
        break;
      case 5:
        content = '疑似代理记账';
        break;
      default:
    }

    return prefix + content;
  },

  dateToTime(value, format = 'YYYY-MM-DD', getHourLabel) {
    if (value && value != '0') {
      let date = dateFns.format(parseInt(value), format);
      if (getHourLabel) {
        let config = date.split(':');
        if (config[0] > 12) {
          return ' 下午 ' + date;
        } else {
          return ' 上午 ' + date;
        }
      } else {
        return date;
      }
    } else if (value === 0) {
      let date = dateFns.format(parseInt(value), format);
      return date;
    } else {
      return '-';
    }
  }
};

export default filters;



// WEBPACK FOOTER //
// ./src/filter/index.js